import { useExperiments } from '@wix/yoshi-flow-editor';
import { EXPERIMENTS } from 'root/experiments';

export const useIsFeaturedTypeEnabled = () => {
  const { experiments } = useExperiments();

  return experiments.enabled(EXPERIMENTS.ITEM_FEATURED_TYPE);
};
